import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/Home";
import TempleList from "../pages/TempleList";
import TempleDetail from "../pages/TempleDetail";
import Gallery from "../pages/Gallery";
import PlanVisit from "../pages/PlanVisit";
import FAQ from "../pages/FAQ";
import About from "../pages/About";
import MapView from "../pages/MapView";

import Login from "../pages/Login";
import Signup from "../pages/Signup";

import AuthRoute from "../components/AuthRoute";

function AppRouter() {

  const token =
    localStorage.getItem("token");

  return (

    <Routes>

      {/* ---------- DEFAULT OPEN APP ---------- */}
      <Route
        path="/"
        element={
          <Home />

          // token
          //   ? (
          //     <AuthRoute>
          //       <Home />
          //     </AuthRoute>
          //   )
          //   : (
          //     <Navigate
          //       to="/login"
          //       replace
          //     />
          //   )
        }
      />

      {/* ---------- LOGIN ---------- */}
      {/* <Route
        path="/login"
        element={<Login />}
      /> */}

      {/* ---------- SIGNUP ---------- */}
      {/* <Route
        path="/signup"
        element={<Signup />}
      /> */}

      {/* ---------- PROTECTED ROUTES ---------- */}

      <Route
        path="/temples"
        element={
          <TempleList />


          // <AuthRoute>
          //   <TempleList />
          // </AuthRoute>
        }
      />

      <Route
        path="/temple/:id"
        element={
          <TempleDetail />
          // <AuthRoute>
          //   <TempleDetail />
          // </AuthRoute>
        }
      />

      <Route
        path="/gallery"
        element={
          <Gallery />

          // <AuthRoute>
          //   <Gallery />
          // </AuthRoute>
        }
      />

      <Route
        path="/gallery/:id"
        element={
          <Gallery />

          // <AuthRoute>
          //   <Gallery />
          // </AuthRoute>
        }
      />

      <Route
        path="/plan"
        element={
          <PlanVisit />

          // <AuthRoute>
          //   <PlanVisit />
          // </AuthRoute>
        }
      />

      <Route
        path="/faq"
        element={
          <FAQ />

          // <AuthRoute>
          //   <FAQ />
          // </AuthRoute>
        }
      />

      <Route
        path="/about"
        element={
          <About />

          // <AuthRoute>
          //   <About />
          // </AuthRoute>
        }
      />

      <Route
        path="/map/:id"
        element={
          <MapView />

          // <AuthRoute>
          //   <MapView />
          // </AuthRoute>
        }
      />

    </Routes>

  );

}

export default AppRouter;